import Logger from 'utils/Logger';

import { AppendAnonymousSessionData } from './anonymous-session/append-anonymous-session-data';
import { GetAnonymousSessionData } from './anonymous-session/get-anonymous-session-data';
import { UpdateAnonymousSessionData } from './anonymous-session/update-anonymous-session-data';
import { RequestAppointment } from './appointment/request-appointment';
import { GetExperimentVariants } from './experiment/get-experiment-variants';
import { RequestOffer } from './offer/request-offer';
import { RequestReferralPromotion } from './offer/request-referral-promotion';
import { RequestPatientPhoneVerification, VerifyPatientPhone } from './patient/unverified-phone';
import { UpdatePatientDetails } from './patient/update-details';
import { RequestEmailVerification, RequestPhoneVerification, RequestPhoneVerificationSmsStatus, VerifyEmail, VerifyPhone } from './patient/verify';
import { ValidateReservedAppointmentSlot } from './reserved-appointment-slot/validate-slot';
import { UpdatePatientSilently } from './update-patient-silently/update-patient-silently';
import { UpsertIterableUser } from './upsert-iterable-user/upsert-iterable-user';
import { Authenticate } from './user/authenticate';
import { CheckOtp } from './user/otp/check-otp';
import { VerifyOtp } from './user/otp/verify-otp';
import { Signup } from './user/signup';
import { SignupWithOffer } from './user/signup-with-offer';
import { UserMarketName } from './user/user-market-name';

export class SagaHandlerRegistry {
  constructor(handlers) {
    this._handlers = handlers || [
      // Authentication
      Authenticate,
      CheckOtp,
      VerifyOtp,

      // Signup
      Signup,
      SignupWithOffer,

      // User info
      UserMarketName,

      // Offers
      RequestOffer,
      RequestReferralPromotion,

      // Anonymous session
      GetAnonymousSessionData,
      UpdateAnonymousSessionData,
      AppendAnonymousSessionData,

      // Patient
      UpdatePatientSilently,
      UpdatePatientDetails,

      // Verify
      VerifyEmail,
      VerifyPhone,
      RequestEmailVerification,
      RequestPhoneVerification,
      RequestPhoneVerificationSmsStatus,

      // Verify Patient Phone
      RequestPatientPhoneVerification,
      VerifyPatientPhone,

      // Appointment
      RequestAppointment,

      // Reserved Appointment Slot
      ValidateReservedAppointmentSlot,

      // API Endpoints
      UpsertIterableUser,

      // Experiments
      GetExperimentVariants,
    ];

    // Inject handlers with dependencies
    // This allows handlers to access other handlers without circular dependencies
    //
    // Injecting them when the registry is created instead of when the handler runs
    // allows us to throw an error when the app starts instead of when the handler runs
    this._handlers.forEach((handler) => {
      handler.injectDependencies(this);
    });
  }

  getHandlers() {
    return this._handlers;
  }

  getHandler(actionName) {
    const handler = this.getHandlers()
      .find((h) => h.actionName === actionName);

    if (!handler) {
      const error = new Error(
        `Could not find handler with action name: ${actionName}`,
      );
      Logger.error('SagaHandlerRegistry', error);
      throw error;
    }

    return handler;
  }
}
